/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react'
import { Grid } from '@mui/material'
import { CloseButton, Container, SaveButton } from './ClientMmDetails.style'
import { MODAL_TYPE, routes } from '../../../utils/constants'
import useAxios from '../../../hooks/useAxios'
import PropTypes from 'prop-types'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { handelNotifications } from '../../../redux/slices/Notification/notificationSlice'
import LuceraDropValue from './components/LuceraDropValue'
import ProductPermission from './components/ProductPermission'
import CounterpartySetting from './components/CounterpartySetting'
import TradingAccountHeader from './components/TradingAccountHeader'
import useLuceraDropValue from './hook/useLuceraDropValue'
import useProductPermission from './hook/useProductPermission'
import BookingRecaption from '../../../components/BookingRecaption/BookingRecaption'
import useBookingRecaption from '../../../components/BookingRecaption/hook/useBookingRecaption'
import { areArrayEqual, arraysObjectEqual } from '../../../helper'

function ClientMmDetails({ clientMmId, userType, getEntitiesDetails }) {
  const dispatch = useDispatch()
  const token = useSelector(state => state.auth.token)
  const entitlements = useSelector(state => state.auth.entitlements)
  const [productPermissionError, setProductPermissionError] = useState({})
  const [currencyNormalize, setCurrencyNormalize] = useState({})
  const [search, setSearch] = useState({ search: '' })
  const [form, setForm] = useState({
    lucera_drop_value: [],
    makor_company: '',
    shortname: '',
    emails: [],
    prime_broker_mapping: '',
    pb_agreement: '',
    is_pba: '',
    limit_m: 0,
    makor_prime_broker: '',
    is_structured: true
  })

  const [copyForm, setCopyForm] = useState({
    lucera_drop_value: [],
    makor_company: '',
    shortname: '',
    emails: [],
    prime_broker_mapping: '',
    pb_agreement: '',
    is_pba: '',
    limit_m: 0,
    makor_prime_broker: '',
    is_structured: true
  })

  const [counterPartyPrimeBrokerInfo, setCounterPartyPrimeBrokerInfo] = useState({
    makor_prime_broker: '',
    prime_broker_mapping: '',
    makor_company: ''
  })
  const [active, setActive] = useState(true)
  const [role, setRole] = useState('Client')
  const [giveUp, setGiveUp] = useState(true)
  const [activeButton, setActiveButton] = useState('Spot')
  const [currencyPermissionData, setCurrencyPermissionData] = useState({})
  const [copyCurrencyPermissionData, setCopyCurrencyPermissionData] = useState({})
  const [deleteCurrencyPermissionData, setDeleteCurrencyPermissionData] = useState([])
  const modal = useSelector(state => state.modal)
  const buttonLabels = useMemo(
    () => ['Spot', 'Forward', 'Vanilla Option', 'Exotic Option', 'Swap'],
    []
  )

  const request = {
    endPoint: routes.contractDistribution,
    params: search
  }
  const { response: contractDistribution, setResponse: setResponseContractDistribution } =
    useAxios(request)

  const { addLuceraRows, handelLuceraDropValue, handleDeleteLuceraValue } = useLuceraDropValue({
    form,
    setForm
  })

  const { submitNewContract, handelEmail } = useBookingRecaption({
    setSearchEmail: setSearch,
    searchEmail: search,
    form,
    setForm,
    contractDistribution,
    setResponseContractDistribution
  })

  const {
    handleNavButtonClick,
    handleTenorChange,
    handelPermissionClick,
    getCurrencyPermissionData,
    handelBlur,
    handelFocus,
    handelRemovePermission
  } = useProductPermission({
    setActiveButton,
    clientMmId,
    token,
    activeButton,
    setCopyCurrencyPermissionData,
    setCurrencyPermissionData,
    currencyPermissionData,
    userType,
    productPermissionError,
    setProductPermissionError,
    currencyPermissionData,
    copyCurrencyPermissionData,
    setDeleteCurrencyPermissionData,
    currencyNormalize
  })

  const readOnlyMode = () => !entitlements.includes('Static')

  const getMarketMakerById = async () => {
    const url = process.env.REACT_APP_SERVER_URL.concat(routes.marketMaker, '/', clientMmId)
    try {
      const result = await axios.get(url, { headers: { Authorization: token } })
      const updatedLuceraDropValue = result.data.lucera_drop_value
      const data = {
        lucera_drop_value: updatedLuceraDropValue,
        market_maker_name: result.data.name,
        shortname: result.data.shortname,
        makor_company: result.data.makor_company,
        emails: result.data.market_maker_mailing_list,
        prime_broker_mapping: result.data.prime_broker_mapping || '',
        limit_m: result.data.limit_m || 0,
        makor_prime_broker: result.data.makor_prime_broker,
        is_pba: !!result.data.is_pba,
        pb_agreement: result.data.pb_agreement || '',
        is_buyside: !!result.data.is_buyside,
        is_active: !!result.data.is_active
      }
      setForm(data)
      setCopyForm(data)
      setCounterPartyPrimeBrokerInfo({
        makor_prime_broker: result.data.makor_prime_broker,
        makor_company: result.data.makor_company
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getClientById = async () => {
    const url = process.env.REACT_APP_SERVER_URL.concat(routes.client, '/', clientMmId)
    try {
      const result = await axios.get(url, { headers: { Authorization: token } })
      const updatedLuceraDropValue = result.data.lucera_drop_value
      const data = {
        lucera_drop_value: updatedLuceraDropValue,
        client_name: result.data.name,
        shortname: result.data.shortname,
        makor_company: result.data.makor_company,
        emails: result.data.client_mailing_list,
        prime_broker_mapping: result.data.prime_broker_mapping || '',
        limit_m: result.data.limit_m || 0,
        makor_prime_broker: result.data.makor_prime_broker,
        is_pba: !!result.data.is_pba,
        pb_agreement: result.data.pb_agreement || '',
        is_buyside: !!result.data.is_buyside,
        is_active: !!result.data.is_active
      }
      setForm(data)
      setCopyForm(data)
      setCounterPartyPrimeBrokerInfo({
        makor_prime_broker: result.data.makor_prime_broker,
        makor_company: result.data.makor_company
      })
    } catch (error) {
      console.log(error)
    }
  }

  const getNormalizeCurrency = async () => {
    try {
      const url = process.env.REACT_APP_SERVER_URL.concat(routes.currencyNormalize)
      const result = await axios.get(url, { headers: { Authorization: token } })
      setCurrencyNormalize(result.data)
    } catch (error) {
      console.log(error)
    }
  }

  const cancelChange = async () => {
    setForm(copyForm)
    setCurrencyPermissionData(copyCurrencyPermissionData)
  }

  const submit = async () => {
    if (Object.keys(productPermissionError).length) {
      dispatch(
        handelNotifications({
          id: Date.now(),
          type: 'error',
          message: 'There has been an issue saving the product permissions'
        })
      )
      return
    }
    if (userType === 'client' && deleteCurrencyPermissionData.length) {
      const url = process.env.REACT_APP_SERVER_URL.concat(
        routes.clientPermission,
        '/delete/',
        clientMmId
      )
      try {
        await axios.put(url, deleteCurrencyPermissionData, { headers: { Authorization: token } })
      } catch (error) {
        console.log(error)
      }
    }
    if (userType === 'market maker' && deleteCurrencyPermissionData.length) {
      const url = process.env.REACT_APP_SERVER_URL.concat(
        routes.marketMakerPermission,
        '/delete/',
        clientMmId
      )
      try {
        await axios.put(url, deleteCurrencyPermissionData, { headers: { Authorization: token } })
      } catch (error) {
        console.log(error)
      }
    }

    if (userType === 'client') {
      const url = process.env.REACT_APP_SERVER_URL.concat(routes.clientPermission, '/', clientMmId)
      try {
        await axios.put(url, currencyPermissionData, { headers: { Authorization: token } })
        await getCurrencyPermissionData()
      } catch (error) {
        console.log(error)
      }
    }
    if (userType === 'market maker') {
      const url = process.env.REACT_APP_SERVER_URL.concat(
        routes.marketMakerPermission,
        '/',
        clientMmId
      )
      try {
        await axios.put(url, currencyPermissionData, { headers: { Authorization: token } })
        await getCurrencyPermissionData()
      } catch (error) {
        console.log(error)
      }
    }
    const urlClient = process.env.REACT_APP_SERVER_URL.concat(routes.client)
    const urlMm = process.env.REACT_APP_SERVER_URL.concat(routes.marketMaker)
    try {
      const lucera_drop_value = form.lucera_drop_value.filter(
        luceraValue => luceraValue.type && luceraValue.lucera
      )
      let prime_broker_mapping = form.prime_broker_mapping || null

      const data = { ...form, id: clientMmId, lucera_drop_value, prime_broker_mapping }
      if (data.limit_m === 0) {
        delete data.limit_m
      }
      if (form.pb_agreement === '') {
        data.pb_agreement = null
      }
      if (userType === 'client') {
        try {
          await axios.put(
            urlClient,
            { ...data, id: clientMmId },
            { headers: { Authorization: token } }
          )
          await getClientById()
        } catch (error) {
          console.log(error)
        }
      } else {
        try {
          await axios.put(urlMm, { ...data, id: clientMmId }, { headers: { Authorization: token } })
          await getMarketMakerById()
        } catch (error) {
          console.log(error)
        }
      }
      if (
        counterPartyPrimeBrokerInfo.makor_company !== form.makor_company ||
        counterPartyPrimeBrokerInfo.makor_prime_broker !== form.makor_prime_broker
      ) {
        await getEntitiesDetails()
      }
    } catch (error) {
      if (Array.isArray(error?.response?.data))
        for (const { message } of error.response.data) {
          dispatch(
            handelNotifications({
              id: Date.now(),
              type: 'error',
              message: message
            })
          )
        }
    }
  }

  const handelBookingRecaption = event => {
    const { value, checked } = event.target
    const copyForm = JSON.parse(JSON.stringify(form))
    if (checked) {
      copyForm.emails.push(value)
    } else if (!checked) {
      const elementIndex = copyForm.emails.indexOf(value)
      copyForm.emails.splice(elementIndex, 1)
    }
    setForm(copyForm)
  }

  const isCopyDataEqualToNewData = () => {
    if (deleteCurrencyPermissionData.length) {
      return false
    }
    const formKeys = Object.keys(form)
    for (const key of formKeys) {
      if (
        ['string', 'number', 'boolean'].includes(typeof form[key]) &&
        copyForm[key] !== form[key]
      ) {
        return false
      }
      if (key === 'emails') {
        if (!areArrayEqual(form[key], copyForm[key])) {
          return false
        }
      }
      if (key === 'lucera_drop_value') {
        if (!arraysObjectEqual(form[key], copyForm[key])) {
          return false
        }
      }
    }
    const currencyPermissionsKey = Object.keys(currencyPermissionData)
    for (const key of currencyPermissionsKey) {
      if (!arraysObjectEqual(currencyPermissionData[key], copyCurrencyPermissionData[key]))
        return false
    }
    return true
  }

  useEffect(() => {
    getNormalizeCurrency()
  }, [])
  // calling when change entities side
  useEffect(() => {
    if (userType === 'client') {
      setRole('Client')
      getClientById()
      handleNavButtonClick(activeButton, userType)
      getCurrencyPermissionData()
      setProductPermissionError({})
      setDeleteCurrencyPermissionData([])
    } else if (userType === 'market maker') {
      setRole('Market Maker')
      getMarketMakerById()
      handleNavButtonClick(activeButton, userType)
      getCurrencyPermissionData()
      setProductPermissionError({})
      setDeleteCurrencyPermissionData([])
    } else if (userType === 'trader') {
      setRole('Trader')
      setProductPermissionError({})
      setDeleteCurrencyPermissionData([])
    }
  }, [clientMmId, userType])

  //calling when adding new permission
  useEffect(() => {
    if (modal.type == MODAL_TYPE.PERMISSION && modal.getRequest === true) {
      getCurrencyPermissionData()
    }
  }, [modal, activeButton, userType])

  return (
    <Container container read_only={String(readOnlyMode())}>
      <Grid item xs={12}>
        <TradingAccountHeader
          form={form}
          setForm={setForm}
          active={active}
          setActive={setActive}
          userType={userType}
        />
        <Grid
          container
          style={{
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            marginTop: '12px',
            height: 'auto'
          }}
        >
          <CounterpartySetting
            role={role}
            form={form}
            setForm={setForm}
            giveUp={giveUp}
            setGiveUp={setGiveUp}
          />
          <LuceraDropValue
            form={form}
            addLuceraRows={addLuceraRows}
            handelLuceraDropValue={handelLuceraDropValue}
            handleDeleteLuceraValue={handleDeleteLuceraValue}
          />
          {Array.isArray(contractDistribution.data) && (
            <Grid item xs={4} style={{ display: 'flex', flexDirection: 'column' }}>
              <BookingRecaption
                form={form}
                searchEmail={search}
                handelEmail={handelEmail}
                handelFormChange={handelBookingRecaption}
                contractDistribution={contractDistribution}
                submitNewContract={submitNewContract}
                style={{ background: '#242428', maxHeight: '300px', height: '290px' }}
                backgroundSearchBarContainer={'#242428'}
                backgroundSearchBar="#39393C"
                pageArea={'Entity'}
              />
            </Grid>
          )}
        </Grid>

        <ProductPermission
          buttonLabels={buttonLabels}
          activeButton={activeButton}
          limitM={form.limit_m}
          setForm={setForm}
          setActiveButton={setActiveButton}
          currencyPermissionData={currencyPermissionData}
          productPermissionError={productPermissionError}
          handelBlur={handelBlur}
          handelFocus={handelFocus}
          handleTenorChange={handleTenorChange}
          handelPermissionClick={handelPermissionClick}
          handelRemovePermission={handelRemovePermission}
        />
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginTop: '20px',
            marginBottom: '30px'
          }}
        >
          <CloseButton onClick={cancelChange}>Discard Changes</CloseButton>
          <SaveButton onClick={submit} disabled={isCopyDataEqualToNewData()}>
            Save Changes
          </SaveButton>
        </Grid>
      </Grid>
    </Container>
  )
}

ClientMmDetails.propTypes = {
  params: PropTypes.object,
  clientMmId: PropTypes.string,
  userType: PropTypes.string,
  getEntitiesDetails: PropTypes.func
}

export default ClientMmDetails
